<template>
  <div class="d-flex">
    <TheSidebar
      @mouseenter="hovering = true"
      @mouseleave="hovering = false"
    ></TheSidebar>
<!--    <div-->
<!--      class="flex-grow-1"-->
<!--      :class="{ darken: hovering }"-->
<!--      style="flex-basis: auto; background: var(&#45;&#45;bg-color);
transition: filter 0.3s ease;"-->
<!--    >-->
    <div
      class="flex-grow-1"
      style="flex-basis: auto; background: var(--bg-color); transition: filter 0.3s ease;"
    >
      <router-view class="mt-5" v-cloak/>
    </div>
  </div>
</template>

<script>
import TheSidebar from '../components/TheSidebar.vue';

export default {
  components: {
    TheSidebar,
  },
  name: 'UserLayout',
  mounted() {
    // if (!this.$store.state.authorized) {
    //   this.$router.push('Login');
    // }
  },
};
</script>

<style scoped>

</style>
